import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  PlacementArray,
} from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@rocksoft/locations-sdk';
import { RouteLinkInput } from '../../models/router-link.model';

@Component({
  selector: 'era-select-location-list-ui',
  templateUrl: './select-location-list.component.html',
  styleUrls: ['./select-location-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink],
})
export class SelectLocationListComponent {
  public readonly locations = input<Location[]>([]);
  public readonly location = input.required<Location>();
  public readonly brandId = input<string | undefined>(undefined);
  public readonly header = input(false);
  public readonly route = input.required<RouteLinkInput>();
  public readonly placeholder = input.required<string>();
  public readonly placement = input.required<PlacementArray>();
}
